import { createContext, type ReactNode, useContext } from "react";

/** `toolbar` — a view block inside an article, `panel` — the catalog report panel. */
export type ViewSurfaceVariant = "toolbar" | "panel";

const ViewSurfaceVariantContext = createContext<ViewSurfaceVariant>("toolbar");

export const useViewSurfaceVariant = () => useContext(ViewSurfaceVariantContext);

export const ViewSurfaceVariantProvider = ({
	variant,
	children,
}: {
	variant: ViewSurfaceVariant;
	children: ReactNode;
}) => <ViewSurfaceVariantContext.Provider value={variant}>{children}</ViewSurfaceVariantContext.Provider>;
